import React from "react";
import Spinner from "../Spinner/Spinner";
import Header from "../header";
import axios from "axios";
import { apiCall_domain } from "../api";
class selectedCity extends React.Component {
  state = {
    cities: null,
    loading: true,
    changeDetail: true,
  };

  componentDidMount() {
    this.setState({ cities: this.props.location.cities, loading: false });
  }

  finalCity = (cityName, cityId) => {
    const city_id = cityId;
    const name = this.props.location.name;
    const Headers = {
      Authorization: localStorage.getItem("Api_key"),
      "content-type": "application/json",
    };
    axios.post(
      `${apiCall_domain}/customer/user`,
      { city_id, name },
      {
        headers: Headers,
      },
    );
    localStorage.setItem("defaultCity", cityName);
    this.props.history.push({
      pathname: "/",
    });
  };

  render() {
    return (
      <>
        {this.state.loading ? (
          <Spinner />
        ) : (
          <>
            <div className="ChangeCity">
              <Header
                showSearchBar={true}
                title={"انتخاب شهر"}
                isDarkTheme={true}
              />
              <div className="innerChangeCity">
                <div className="selected"></div>
                <div className="cityLists">
                  {this.state.cities &&
                    this.state.cities.map((item, i) => (
                      <>
                        <div
                          className="cityRow"
                          onClick={() => this.finalCity(item.name, item.id)}
                        >
                          <span className="city" key={i}>
                            {item.name}
                          </span>
                        </div>
                        <div className="cityDivider" />
                      </>
                    ))}
                </div>
              </div>
            </div>
          </>
        )}
      </>
    );
  }
}
export default selectedCity;
